// Public media the webapp references directly: feed-type thumbnails, demo
// videos, placeholder pictures. Production reads them from their GCS buckets;
// Azure staging reads a copy kept under the same "<bucket>/<path>" names. The
// base is set per stage in config/config.js (REACT_APP_ASSETS).
const ASSETS_BASE = process.env.REACT_APP_ASSETS || "https://storage.googleapis.com";

export const assetUrl = (bucketPath: string) => `${ASSETS_BASE}/${bucketPath}`;
